module.exports = __webpack_public_path__ + "static/img/Zurqui logotipo ORIGINAL_1080px-06.ef00c4a8.png";